module.exports = __webpack_public_path__ + "static/img/8.03d09d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/8.png
// module id = HuQi
// module chunks = 0